import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import axios from 'axios';
import { apiUrl} from'../Config/Config';


	
class Add extends Component {

	constructor(props)
	{
		// CheckAuth();
		super();	
		this.state = {
			name:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'active',
            selectedMenu:{},
            modulelist:'',
            rolelist:''
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChange = this.handleChange.bind(this);

    }
    componentDidMount() {}
	  
	handleChange = selectedOption => {
        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };

    handleInputChange = (e) => {
		const { name, value } = e.target;
		if (name === "priority" && value !== "" && Number(value) < 1) {
			this.setState({ [name]: 1 }); 
		} else {
			this.setState({ [name]: value });
		}
	};

    handleSubmit = () => {
		if(this.validateForm()){
			const formdata = this.state;
			var qs = require('qs');
			var status = '';

			if(formdata.selectedvalue === ''){
			status =formdata.selectedOption.value;
			}else{
			status = formdata.selectedvalue;
			}
			
			var postObject ={
				admin_id: localStorage.getItem('admin_id'),
				name : formdata.name,
				priority : formdata.priority,
				status: status,
				link_to: this.state.linkToValue ? this.state.linkToValue.value : '',
				ai_description: formdata.ai_description
			}	
			axios.post(apiUrl + "AdvisoryDropdown/add", qs.stringify(postObject)).then(res => {
				if(res.data.status === "success"){
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					setTimeout(
					function() {
						$('.success_message').html(this.props.history.push('/advisorydropdown'));
					}
					.bind(this),
					3000
					);
				}else{
					$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
					
					setTimeout(
					function() {
						$('.success_message').html('');
					}
					.bind(this),
					3000
					);
				}
			});
		}
	}

	validateForm() {
		const { name, priority, ai_description } = this.state;
		let formIsValid = true;

		// Validate name
		if (!name || name.trim() === "") {
			formIsValid = false;
			$(".error_name").html('<span class="errorspan">Please fill the field</span>');
		} else {
			$(".error_name").html("");
		}

		// Validate priority
		if (!priority || isNaN(priority) || Number(priority) < 1) {
			formIsValid = false;
			$(".error_priority").html('<span class="errorspan">Priority must be 1 or greater</span>');
		} else {
			$(".error_priority").html("");
		}

		if (!ai_description || ai_description.trim() === "") {
			formIsValid = false;
			$(".error_ai_description").html('<span class="errorspan">Please fill the field</span>');
		} else {
			$(".error_ai_description").html("");
		}

		return formIsValid;
	}
    
	handleLinkToChange = (option) => {
		this.setState({ linkToValue: option });
	};
	

  render() {
    const linkToOptions = [
		{ value: 'chatgpt', label: 'ChatGpt' },
		{ value: 'mca', label: 'MCA' },
		{ value: 'bookkeeping', label: 'Book Keeping' },
		{ value: 'financial_advisor', label: 'Financial Advisor' },
		{ value: 'bank_statement', label: 'Bank Statement' },
		{ value: 'profit_loss', label: 'Profit and Loss' }
	];
	
	const {selectedOption} = this.state;
    return (
      <div className="wrapper"> 
 
	  <Header />
      <MenuSidebar currentpage="advisorydropdown" />  

	<div id="location-error"></div>
	<div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div className="title">
				<h4>Add Advisory Dropdown</h4>				
			</div>
			 <form className="edit"  onSubmit={ e => { this.handleSubmit(this); e.preventDefault(); }}>
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Name<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="name" onChange={this.handleInputChange} className="form-control" value={this.state.name}/>
					<div className="error_name"></div>
				</div>

				<div className="form-group">					
					<label>
						Link To <span className="required" style={{ color: "red" }}> * </span> :
					</label>
					<Select 
						name="link_to"
						value={this.state.linkToValue || linkToOptions[0]} 
						options={linkToOptions} 
						isSearchable={false}
						onChange={this.handleLinkToChange}
					/>
				</div>

				<div className="form-group">
					<label>AI Description<span class="required" style={{ color: "red" }} > * </span> :</label>
				    <textarea name="ai_description" onChange={this.handleInputChange} className="form-control" value={this.state.ai_description}/>
					<div className="error_ai_description"></div>
				</div>
				
			</div>
                  
			<div className="form-right">
                <div className="form-group">
					<label>Priority<span class="required" style={{ color: "red" }} > * </span> :</label>
				    <input type="number"name="priority" min="1" onChange={this.handleInputChange} className="form-control" value={this.state.priority}/>
					<div className="error_priority"></div>
				</div>
				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
                    <Select 
                        name="status"
                        value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                        options={lang.common.status_option} 
                        isSearchable = {false}
                        onChange={this.handleChange}
                    />
	           </div> 
			</div>	
			</div>		
			<div className="btn-group export">	
				<button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" >
					Submit
			   </button>
			 
			</div>
			</form>
			</div>
				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Add));